import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { withSnackbar } from 'notistack';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getUser } from '../../helpers/token';
import Referrals from './Contest/Referrals';
import DashboardCard from './DashboardCard';

const Contest = props => {
  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      props.enqueueSnackbar(notification.message, { variant });
    }
  };

  return (
    <>
      <Grid container spacing={0} justifyContent="center" className="p-1 mt-5">
        <Grid item className="p-1" lg={6} md={6} sm={12} xs={12}>
          <DashboardCard
            titleSize="h5"
            title="Refer a friend"
            content={
              <>
                <FormLabel component="legend">
                  Invite your friends to TravelFeed! Your referral link:
                </FormLabel>
                <div>
                  <CopyToClipboard
                    text={`https://travelfeed.com/join?ref=${getUser()}`}
                    onCopy={() =>
                      newNotification({
                        success: true,
                        message: 'Copied your referral link to your clipboard',
                      })
                    }
                  >
                    <TextField
                      variant="filled"
                      fullWidth
                      margin="dense"
                      multiline
                      value={`https://travelfeed.com/join?ref=${getUser()}`}
                    />
                  </CopyToClipboard>
                </div>
              </>
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={0} justifyContent="center" className="p-1 mt-3">
        <Grid item className="p-1" lg={6} md={6} sm={12} xs={12}>
          <Referrals />
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(Contest);
